<template>
  <div>
    <split-pane :min-percent="20" :default-percent="50" split="vertical">
      <template slot="paneL" v-if="!isShowPic">
        <a-card title="学生列表">
          <!--          <a slot="extra">-->
          <!--            <a-tooltip title="提醒逻辑：1.本期平均值 低于 往期平均值 * ( 1 - 阈值% )。2.计算逻辑：先取个人单日情绪值再取所有学生平均值。3.去除周期内超一半日期无抓拍数据学生，去除双休日法定节假日数据。4.时间跨度须以周为单位较为精准，周一开始，周日结束。">-->
          <!--              <a-icon type="info-circle" style="cursor: pointer;"/>-->
          <!--            </a-tooltip>-->
          <!--          </a>-->
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-item label="时间范围">
                    <a-range-picker :value="rangeDate" @change="onRangeChange" />
                  </a-form-item>
                </a-col>

                <a-col :span="8">
                  <a-form-item label="学生姓名">
                    <a-input placeholder="请输入学生姓名" v-model="queryParam.name"></a-input>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :xl="8" :lg="7" :md="8" :sm="24">
                  <a-form-item label="年级名称">
                    <j-search-select-tag
                      placeholder="请选择年级"
                      v-model="queryParam.gradeId"
                      dict="school_grade,grade_name,id,delete_flag=0"
                      :async="false"
                      style="width: 100%"
                    ></j-search-select-tag>
                  </a-form-item>
                </a-col>

                <a-col :xl="8" :lg="7" :md="8" :sm="24">
                  <a-form-item label="班级名称">
                    <j-search-select-tag
                      placeholder="请选择班级"
                      v-model="queryParam.classId"
                      dict="school_class,name,id,delete_flag=0"
                      :async="false"
                      style="width: 100%"
                    ></j-search-select-tag>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="是否关爱名单">
                    <j-dict-select-tag
                      v-model="queryParam.careList"
                      placeholder="请选择是否关爱名单"
                      dictCode="yn"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="10" v-if="userInfo().username !== 'admin'">
                  <a-form-item label="提醒阈值">
                    <j-dict-select-tag
                      v-model="queryParam.threshold"
                      placeholder="请选择提醒阈值范围"
                      dictCode="warn_level"
                      style="width: calc(50% - 9px)"
                    />
                    ~
                    <j-dict-select-tag
                      v-model="queryParam.thresholdEnd"
                      placeholder="请选择提醒阈值范围"
                      dictCode="warn_level"
                      style="width: calc(50% - 9px)"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="10" v-else>
                  <a-form-item label="提醒阈值范围">
                    <a-input
                      type="number"
                      v-model="queryParam.threshold"
                      :min="0"
                      :max="100"
                      style="width: calc(50% - 9px)"
                    />
                    ~
                    <a-input
                      type="number"
                      v-model="queryParam.thresholdEnd"
                      :min="0"
                      :max="100"
                      style="width: calc(50% - 9px)"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="7">
                  <a-form-item label="持续低落天数">
                    <a-input
                      type="number"
                      v-model="queryParam.continuedLowDays"
                      :min="0"
                      :max="100"
                      style="width: 100%"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="7">
                  <a-form-item label="持续低落次数">
                    <a-input
                      type="number"
                      v-model="queryParam.continuedLowCount"
                      :min="0"
                      :max="100"
                      style="width: 100%"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="10">
                  <a-form-item label="提醒模型">
                    <j-multi-select-tag
                      dictCode="mood_model_test"
                      :options="options"
                      :maxTagCount="1"
                      placeholder="请选择提醒模型"
                      v-model="queryParam.modelIds"
                    ></j-multi-select-tag>
                  </a-form-item>
                </a-col>

                <a-col :span="4">
                  <span
                    style="float: left; overflow: hidden"
                    class="table-page-search-submitButtons"
                  >
                    <a-button type="primary" @click="loadData" icon="search" :loading="loading">
                      查询
                    </a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>

          <!-- 操作按钮区域 -->
          <div class="table-operator">
            <a-button type="primary" icon="download" @click="chartToImg" :loading="loading">
              导出
            </a-button>
          </div>

          <div>
            <a-table
              ref="table"
              size="middle"
              :scroll="{ x: 'auto', y: 450 }"
              bordered
              rowKey="id"
              :columns="columnsWithOutHidden"
              :dataSource="dataSource"
              :loading="loading"
              loading-text="loadingText"
              :pagination="false"
              @change="handleTableChange"
            >
              <a
                slot="studentName"
                :style="text === currentStudentName ? 'color:red' : ''"
                slot-scope="text, record"
                @click="changeSelect(record)"
              >
                {{ text }}
              </a>
            </a-table>
          </div>
        </a-card>
      </template>
      <template slot="paneL" v-else>
        <a-card title="照片清单">
          <a-spin tip="加载中..." :spinning="picLoading">
            <a-timeline style="overflow-y: auto; height: 700px">
              <a-timeline-item color="green" v-for="(item, index) in this.picData" :key="index">
                <p>{{ item.name }}</p>
                <div>
                  <div
                    style="width: 100px; display: inline-block"
                    v-for="(pic, uIndex) in item.data"
                    :key="uIndex"
                  >
                    <img
                      style="width: 100px; height: 100px; border: 1px solid #ccc; padding: 5px"
                      :src="getImgView(pic.faceUrl)"
                    />
                    <div v-if="userInfo().username === 'admin'" style="text-align: center">
                      {{ pic.emotion_dictText }}
                    </div>
                  </div>
                </div>
              </a-timeline-item>
            </a-timeline>
          </a-spin>
        </a-card>
      </template>
      <template slot="paneR">
        <a-card title="分析模型">
          <!--          <a-button v-has="'studentPic:show'" v-show="currentStudentName !== ''" type="primary" slot="extra" @click="showPic">{{ isShowPic ? '返回': '查看照片'}}</a-button>-->
          <a-button
            type="primary"
            v-show="currentStudentName !== ''"
            slot="extra"
            @click="derivedInfo"
          >
            导出
          </a-button>
          <a-spin tip="加载中..." :spinning="chartLoading">
            <div ref="exportContent" class="outer-card">
              <StuLineMoodCard
                v-for="(item, index) in studentLineArr"
                :key="index"
                :name="item.name"
                :dataSource="item.dataSource"
                :moodField="item.fileds"
                :studentInfo="item.studentInfo"
                @showImgDetail="showImgDetail(item.studentInfo)"
                :hiddenCompare="true"
                @deleteRecord="deleteRecord"
              />
            </div>
          </a-spin>
        </a-card>
      </template>
    </split-pane>
    <div style="width: 600px" id="exportChart">
      <LineChart
        v-for="(item, index) in exportChartData"
        style="width: 600px; z-index: -9999"
        height="220px"
        :fields="item.fileds"
        :dataSource="item.dataSource"
        :yAxisMultiple="1.15"
      />
    </div>
    <ImgTimeLineModal ref="imgTimeLineModal" />
  </div>
</template>

<script>
import splitPane from 'vue-splitpane'
import '@/assets/less/TableExpand.less'
import { getAction, postAction } from '@api/manage'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import SmoothLineChartMultid from '@/components/chart/SmoothLineChartMultid'
import moment from 'moment'
import { mapGetters } from 'vuex'
import UpdateStudentFaceModal from '../studentInfo/modules/UpdateStudentFaceModal'
import JMultiSelectTag from '../../../components/dict/JMultiSelectTag.vue'
import JSearchSelectTag from '../../../components/dict/JSearchSelectTag.vue'
import StuLineMoodCard from './components/StuLineMoodCard.vue'
import { message } from 'ant-design-vue/es'
import { exportToPdf, handleLineChartData } from '@/utils/util'
import ImgTimeLineModal from './components/ImgTimeLineModal'
import LineChart from '../../../components/echartZyz/components/LineChart.vue'
import html2canvas from 'html2canvas'

export default {
  name: 'StudentWarn',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    LineChart,
    ImgTimeLineModal,
    StuLineMoodCard,
    JSearchSelectTag,
    JMultiSelectTag,
    splitPane,
    SmoothLineChartMultid,
    UpdateStudentFaceModal,
  },
  data() {
    return {
      loading: false,
      loadingText: '',
      queryParam: {
        threshold: 40,
      },
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 40,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '班级',
          align: 'center',
          dataIndex: 'className',
          width: 100,
          ellipsis: true,
        },
        {
          title: '学生',
          align: 'center',
          dataIndex: 'studentName',
          scopedSlots: { customRender: 'studentName' },
          width: 80,
        },
        {
          title: '情绪指数',
          align: 'center',
          children: [
            {
              title: '本期',
              align: 'center',
              dataIndex: 'currScore',
              width: 60,
            },
            {
              title: '往期',
              align: 'center',
              dataIndex: 'hisScore',
              width: 60,
            },
            {
              title: '班级',
              align: 'center',
              dataIndex: 'classScore',
              width: 60,
            },
            {
              title: '年级',
              align: 'center',
              dataIndex: 'gradeScore',
              width: 60,
            },
          ],
        },
        {
          title: '关爱名单',
          align: 'center',
          dataIndex: 'careList',
          width: 80,
          filters: [
            { text: '须关爱', value: 1 },
            { text: '正常', value: 0 },
          ],
          onFilter: (value, record) => record.careList === value,
          customRender: function (t, r, index) {
            return t === 0 ? '否' : '是'
          },
        },
        {
          title: '本学期提醒次数',
          align: 'center',
          dataIndex: 'semesterWarnNum',
          width: 80,
        },
        {
          title: '提醒内容',
          align: 'center',
          dataIndex: 'content',
          width: 80,
        },
      ],
      columnsWithOutHidden: [],
      chartLoading: false,
      selfData: [],
      classData: [],
      gradeData: [],
      warnData: [],
      currentStudentId: '',
      currentStudentName: '',
      isShowPic: false,
      rangeDate: [],
      picLoading: false,
      picData: [],
      options: [],
      multiSeleteTag: '',
      studentLineArr: [],
      //导出export使用
      exportChartData: [],
      url: {
        list: '/statistic/studentMoodModelTest',
        studentWarnAnalysis: '/statistic/studentMoodAnalysis',
        studentFaceList: '/aigoes/studentFace/list',
        childWarnNumTrend: '/statistic/childWarnNumTrend',
        exportXlsUrl: '/statistic/exportStudentMoodXlsTest',
        getMoreStudentMoodData: '/statistic/getMoreStudentMoodData',
        uploadMoodDataImg: '/statistic/uploadMoodDataImg',
      },
    }
  },
  created() {
    this.columnsWithOutHidden = this.columns.filter((item) => !item.hidden)
    this.rangeDate = [moment().subtract(14, 'days'), moment().subtract(1, 'days')]
    this.queryParam.beginDate = moment().subtract(14, 'days').format('YYYY-MM-DD')
    this.queryParam.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD')

    this.loadData()
  },
  methods: {
    ...mapGetters(['userInfo']),
    loadData() {
      this.loading = true
      this.selfData = []
      this.classData = []
      this.gradeData = []
      this.warnData = []
      this.studentLineArr = []
      this.currentStudentId = ''
      this.currentStudentName = ''
      getAction(this.url.list, this.queryParam).then((res) => {
        if (res.success) {
          this.dataSource = res.result
        }
        if (res.code === 500) {
          this.$message.warning(res.message)
        }
        this.loading = false
      })
    },
    changeSelect(record) {
      this.currentStudentId = record.studentId
      this.currentStudentName = record.studentName
      this.loadChartData(record.studentId)
    },
    loadChartData(studentId) {
      const isHasStu = this.studentLineArr.some((item) => item.studentInfo.studentId == studentId)
      if (isHasStu) {
        return
      }
      this.chartLoading = true
      this.queryParam.studentId = studentId
      this.queryParam.dataType = 1

      getAction(this.url.childWarnNumTrend, this.queryParam).then((res) => {
        if (res.success) {
          const { lineData, filedList } = handleLineChartData(res.result)
          const filterFileds = filedList.filter((item) => item != this.currentStudentName)
          const stuObj = {
            name: this.currentStudentName,
            fileds: [...filterFileds, this.currentStudentName],
            dataSource: lineData,
            studentInfo: {
              ...this.queryParam,
              id: this.currentStudentId,
              name: this.currentStudentName,
            },
          }
          this.studentLineArr.unshift(stuObj)
        }
        console.log('学生数据：', this.studentLineArr)

        this.chartLoading = false
      })
    },

    onRangeChange(dates, dateString) {
      this.rangeDate = dates

      this.queryParam.beginDate = dateString[0]
      this.queryParam.endDate = dateString[1]

      this.loadData()
    },
    showPic() {
      this.picLoading = true
      this.isShowPic = !this.isShowPic
      if (this.isShowPic) {
        this.param = JSON.parse(JSON.stringify(this.queryParam))
        this.param.pageNo = 1
        this.param.pageSize = 1000
        this.param.column = 'createTime'
        this.param.order = 'desc'
        this.param.beginDate = moment(this.param.beginDate)
          .subtract(14, 'days')
          .format('YYYY-MM-DD')

        getAction(this.url.studentFaceList, this.param).then((res) => {
          if (res.success) {
            this.picData = this.jsonArrayGroup(res.result.records)
          }
          this.picLoading = false
        })
      }
    },

    jsonArrayGroup(arr) {
      var map = {},
        dest = []
      for (var i = 0; i < arr.length; i++) {
        var ai = arr[i]
        var key = ai.createTime.substring(0, 10)
        if (!map[key]) {
          dest.push({
            name: key,
            data: [ai],
          })
          map[key] = ai
        } else {
          for (var j = 0; j < dest.length; j++) {
            var dj = dest[j]
            if (dj.name == key) {
              dj.data.push(ai)
              break
            }
          }
        }
      }
      return dest
    },
    // 学生折线图信息导出
    derivedInfo() {
      const element = this.$refs.exportContent
      exportToPdf(element, '学生心理情绪档案')
    },
    /**
     * 导出excel携带情绪曲线
     */
    chartToImg() {
      var that = this
      that.exportChartData = []

      that.$confirm({
        title: '提示',
        content: '本次操作将会导出本页所有学生+情绪曲线，确定导出吗?',
        onOk() {
          that.loading = true
          var hide = that.$message.loading('正在获取学生情绪数据...', 0)

          var studentIds = []
          var classIds = []
          var gradeIds = []
          for (var i = 0; i < that.dataSource.length; i++) {
            studentIds.push(that.dataSource[i].studentId)
            classIds.push(that.dataSource[i].classId)
            gradeIds.push(that.dataSource[i].gradeId)
          }
          postAction(that.url.getMoreStudentMoodData, {
            studentIds: studentIds,
            classIds: classIds,
            gradeIds: gradeIds,
            beginDate: that.queryParam.beginDate,
            endDate: that.queryParam.endDate,
          }).then((res) => {
            if (res.success) {
              res.result.forEach((item) => {
                // 本次请求唯一标识
                that.queryParam.key = item.key
                const { lineData, filedList } = handleLineChartData(item.data)
                const stuObj = {
                  id: item.unionId,
                  fileds: filedList,
                  dataSource: lineData,
                }
                that.exportChartData.push(stuObj)
              })
              setTimeout(hide, 0)

              hide = that.$message.loading('正在生成学生情绪曲线...', 0)
              setTimeout(function () {
                const element = window.document.getElementById('exportChart')
                if (element) {
                  // 多次调用html2canvas会导致浏览器内存溢出，采用图片分片模式
                  html2canvas(element, {
                    scale: 1, // 设定为 1，避免 DPI 引起的尺寸翻倍
                  }).then((canvas) => {
                    var unionIds = []
                    var b64s = []

                    // 创建切片
                    for (let i = 0; i < that.exportChartData.length; i++) {
                      let sliceCanvas = document.createElement('canvas')
                      let sliceCtx = sliceCanvas.getContext('2d')
                      sliceCanvas.width = 600
                      sliceCanvas.height = 220

                      // 将当前切片绘制到新 canvas 上
                      sliceCtx.drawImage(canvas, 0, 220 * i, 600, 220, 0, 0, 600, 220)

                      unionIds.push(that.exportChartData[i].id)
                      b64s.push(sliceCanvas.toDataURL('image/png'))
                    }

                    canvas = null

                    // 上传截图
                    postAction(that.url.uploadMoodDataImg, {
                      unionIds: unionIds,
                      b64s: b64s,
                    }).then((res) => {
                      setTimeout(hide, 0)
                      that.$message.loading('正在生成excel...', 5)
                      that.handleExportXls('学生情绪数据分析')
                      that.loading = false
                    })
                  })
                }
              }, 2000)
            }
          })
        },
      })
    },
    // 列表查看详情
    showLineDetail(record) {
      console.log('行信息--', record)
      this.$refs.viewKeyPointModal.show({ id: record.studentId, name: record.studentName }, 2)
    },
    showAddLabel(record) {
      const recordData = {
        studentId: record.studentId,
        // keyword: record.studentName,
        beginDate: this.formData.beginDate,
        endDate: this.formData.endDate,
      }
      this.$refs.addLabelModal.show(recordData)
    },
    // 查看照片详情
    showImgDetail(dataInfo) {
      this.$refs.imgTimeLineModal.show(dataInfo)
    },
    deleteRecord(currStuInfo) {
      const index = this.studentLineArr.findIndex((item) => item.studentInfo.id == currStuInfo.id)
      if (index != -1) {
        this.studentLineArr.splice(index, 1)
        this.$message.success('删除卡片项成功')
      } else {
        this.$message.warning('记录不存在，删除失败')
      }
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
<style>
.ant-table-fixed-header .ant-table-scroll .ant-table-header {
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
  overflow: hidden !important;
  opacity: 0.9999;
  padding-right: 8px;
}
</style>
